import store from '../../store/index';
import defaultSettings from 'settings';
import CEUtils from '@cekit/ce-utils';
const { loginInterceptionType, loginPrivatePath, isRecordRoute, isRequestRoutes, keepAliveList, rootComponent, nodeComponent, affixs, hides, title } = defaultSettings;
// import { getAccessInstance } from '@/utils/access_token';
//import activeRoute from '../modules/r.js';
// 多级嵌套数组处理成一维数组
export function formatFlatteningRoutes(arr) {
    if (arr.length < 0) return false;
    for (let i = 0; i < arr.length; i++) {
        if (arr[i].children) {
            arr = arr.slice(0, i + 1).concat(arr[i].children, arr.slice(i + 1));
        }
    }
    return arr;
}
// 多级嵌套数组处理后的一维数组，再处理成 `定义动态路由` 的格式
// 只保留二级：也就是二级以上全部处理成只有二级，keep-alive 支持二级缓存
// isKeepAlive 处理 `name` 值，进行缓存。顶级关闭，全部不缓存
export function formatTwoStageRoutes(arr) {
    if (arr.length < 0) return false;
    const newArr = [];
    const cacheList = [];
    arr.forEach(v => {
        if (v.path === '/') {
            newArr.push({ component: v.component, name: v.name, path: v.path, redirect: v.redirect, meta: v.meta, children: [] });
        } else {
            newArr[0].children.push({ ...v });
            // if (newArr[0].meta.isKeepAlive && v.meta.isKeepAlive) {
            if (v.path && keepAliveList.includes(v.path.substr(1).replace(/\//g, '-'))) {
                cacheList.push(v.name);
                store.dispatch('routes/setCacheKeepAlive', cacheList);
            }
        }
    });
    return newArr;
}

// 比对后的路由表，进行重新赋值
export function setFilterRouteEnd(accessRoutes) {
    let filterRouteEnd = formatTwoStageRoutes(formatFlatteningRoutes(accessRoutes));
    return filterRouteEnd;
}

/**
 * 登录判定
 * 登录主要通过不同的渠道检查不同的登录信息
 * 如果是 sass （与服务）方式登录，直接调用 sass 单点登录
 */
export async function isLogin() {
    // const token = getSession('token');
    let token = false;
    if (loginInterceptionType === 'saas') {
        token = await store.dispatch('user/loginSaas'); // 返回true false
    } else if (loginInterceptionType === 'private') {
        // 获取本地accessToken，检查获取accessToken属性
        token = store.getters['user/accessToken']; // 返回 字符串
    } else if (loginInterceptionType === 'vistor') {
        // 访客用户不拦截
        token = store.getters['user/accessToken']; // 返回 字符串
    } else {
        throw new TypeError('目前仅支持Saas/private/访客，三种登录方式的菜单! 请检查配置loginInterceptionType');
    }
    if (token) {
        // 水印配置 username配置
        store.dispatch('settings/changeWartermarkText', `${store.getters['user/username']}@300.cn`);
    }
    return token;
}

// 获取当前用户的权限去比对路由表，用于左侧菜单/横向菜单的显示
export async function setFilterMenu() {
    // 角色信息
    let permissions;
    // 菜单
    let accessRoutes = [];
    // 不拦截登录信息-常用于mock数据调试
    if (loginInterceptionType === 'vistor') {
        // loginInterception = false, 登录不拦截则使用访客用户
        // 列出所有菜单的memberCode数组里
        // 初始化访客用户信息
        // 访客模式, 加载本地路由
        // 启用前端路由
        permissions = await store.dispatch('user/getVisitor');
        accessRoutes = await store.dispatch('routes/setVistorRoutes', permissions);
    } else if (loginInterceptionType === 'saas') {
        // 进行拦截确认第三方登录状态 cas拦截,ce新门户网关 todo 区别使用本地和远程 isRequestRoutes
        // if (baseUrlObj.searchQuery && baseUrlObj.searchQuery.instance) {
        permissions = await store.dispatch('user/getSaasUserInfo');
        
        if (isRequestRoutes) {
            // 启用后端路由
            accessRoutes = await store.dispatch('routes/setSaasRoutes', {
                user: store.getters['user/userdata'],
                auth: permissions,
            });
        } else {
            // 启用前端路由
            accessRoutes = await store.dispatch('routes/setVistorRoutes', permissions);
        }
        // }
    } else if (loginInterceptionType === 'private') {
        // 未来私有化登录设计
        permissions = await store.dispatch('user/getPrivateUserInfo');
        // 根据角色获取菜单 , todo 区别使用本地和远程 isRequestRoutes
        if (isRequestRoutes) {
            // 启用后端路由
            accessRoutes = await store.dispatch('routes/setPrivateRoutes', permissions);
        } else {
            // 启用前端路由
            accessRoutes = await store.dispatch('routes/setVistorRoutes', permissions);
        }
    } else {
        throw new TypeError('目前仅支持Saas/private/访客，三种登录方式的菜单! 请检查配置loginInterceptionType');
    }
    // 如果菜单为空则显示登录失败
    if (CEUtils.isEmpty(accessRoutes)) return false;
    // 添加到 vuex setTagsViewRoutes 中
    // 缓存多级嵌套数组处理后的一维数组(tagsView、菜单搜索中使用：未过滤隐藏的(isHide))
    store.dispatch('routes/setTagsViewRoutes', formatTwoStageRoutes(formatFlatteningRoutes([accessRoutes]))[0].children);
    return accessRoutes;
}

export function setLoginUrl(next, to) {
    // 未登录处理登录页面
    if (loginInterceptionType === 'saas') {
        setTimeout(() => {
            next('/999');
        }, 500);
    } else if (loginInterceptionType === 'private') {
        // 私有化登录
        if (to.path === '/') {
            next(loginPrivatePath);
        } else {
            next(isRecordRoute ? `${loginPrivatePath}?redirect=${to.path}` : `${loginPrivatePath}`);
        }
    } else if (loginInterceptionType === 'vistor') {
        store.dispatch('user/getVisitor');
        // initDynamicRoute();
        // 访客登录
        next('/');
    } else {
        // next('/401');
        next('/999');
    }
}

/**
 * @description 设置标题
 * @param pageTitle
 * @returns {string}
 */
export default function getPageTitle(pageTitle) {
    if (pageTitle) {
        return `${pageTitle}-${title}`;
    }
    return `${title}`;
}

/**
 * @description intelligence模式根据permissions数组拦截路由
 * @param routes
 * @param permissions
 * @returns {[]}
 */
export function filterPermissionsRoutes(routes, permissions) {
    // item.meta.permissions为空，或item.meta.permissions里面有数组的权限
    // .filter(item => permissions.some(auth => item.name === auth))
    return routes
        .filter(item => {
            if (typeof permissions === 'string' && permissions === 'all') return true;
            else return permissions.includes(item.code);
        })
        .map(item => {
            item['title'] = item.meta.title;
            item = Object.assign({}, item);
            if (item.children) item.children = filterPermissionsRoutes(item.children, permissions);
            return item;
        });
}

/**
 * @description intelligence模式根据permissions数组拦截路由
 * @param routes
 * @param permissions
 * @returns {[]}
 */
export function filterPermissionsMenus(menus, permissions) {
    // item.meta.permissions为空，或item.meta.permissions里面有数组的权限
    return menus
        .filter(menu => {
            if (typeof permissions === 'string' && permissions === 'all') return true;
            else return permissions.includes(menu.code);
        })
        .map(menu => {
            menu['title'] = menu.meta.title;
            menu = Object.assign({}, menu);
            if (menu.children) menu.children = filterPermissionsMenus(menu.children, permissions);
            return menu;
        });
}

/**
 * @description 导出过滤后的菜单
 * @param routes
 * @returns {[]}
 */
export function filterNotHiddenRoutes(routes) {
    return routes
        .filter(item => !item.meta.isHide)
        .map(item => {
            item['title'] = item.meta.title;
            item = Object.assign({}, item);
            if (item.children) item.children = filterNotHiddenRoutes(item.children);
            return item;
        });
}

/**
 * @description 导出过滤后的菜单
 * @param routes
 * @returns {[]}
 */
export function filterNotHiddenMenus(menus) {
    return menus
        .filter(menu => !menu.meta.isHide)
        .map(menu => {
            menu = Object.assign({}, menu);
            if (menu.children) menu.children = filterNotHiddenMenus(menu.children);
            return menu;
        });
}

// 递归过滤 `isAffix: true` 的数组
export function filterNotAffixRoutes(routes) {
    return routes
        .filter(item => item.meta.isAffix)
        .map(item => {
            item['title'] = item.meta.title;
            item = Object.assign({}, item);
            if (item.children) item.children = filterNotAffixRoutes(item.children);
            return item;
        });
}

/**
 * 对象去重
 * @param {Array} repeatMap
 * @param {String} key
 * @returns
 */
export function mapUnRepeat(repeatMap, key) {
    let map = new Map();
    for (let item of repeatMap) {
        if (!map.has(item[key])) {
            map.set(item[key], item);
        }
    }
    return [...map.values()];
}
function removeNoneMenu(Menus) {
    for (let i = Menus.length - 1; i >= 0; i--) {
        if (!Menus[i].pageUrl) {
            if (!Menus[i].childMenuList || !Menus[i].childMenuList.length) {
                Menus.splice(i, 1);
            } else {
                removeNoneMenu(Menus[i].childMenuList);
                if (!Menus[i].childMenuList.length) {
                    Menus.splice(i, 1);
                }
            }
        }
    }
}
function dealMenu(Menus) {
    removeNoneMenu(Menus);
    // Menu树转换为数组[]结构，去掉childMenuList的子项数据 api参考: http://10.12.68.61:8070/#/
    const menusArray = CEUtils.toTreeArray(Menus, { children: 'childMenuList', clear: false });
    //const activeRoutes = CEUtils.toTreeArray(activeRoute, { children: 'children', clear: false });
    console.log(menusArray, '扁平化菜单');
    menusArray.map(v => {
        // 如果有子集则link置null pageURL = ''
        if (v.childMenuList && v.childMenuList.length > 0) {
            v.externalLink = null;
            v.pageUrl = '';
        }
        if (v.childMenuList == 0 && v.pageUrl == '') {
            v.externalLink = null;
        }
    });
    console.log(menusArray, '过滤后菜单');
    return menusArray;
}

// 数据格式(getMenuListByTenantId.js)=>router
// 菜单项会出现重复的菜单，路由器加载时过滤重复菜单项
export function formatRouterData(Menus, Auths) {
    /**
     * path: "/home",                 // => pageUrl
     * redirect: "/home",             // => 获得子菜单childMenuList的第一个path
     * component: "ce-demo/home",     // => 通过path字典赋值使用的component (根目录使用：layouts/default/index | 父目录：layouts/default/parent ｜ 子项：'/user/user-list')
     * meta: {
     *     parent: "/home",           // => 父节点路径，如果父路径为/ 则为本身的path /home 本例子
     *     icon: "el-icon-s-order",   // => menuIcon
     *     title: "文档",              // => menuName
     *     isAffix: true,             // => 通过 settings 配置固定的菜单
     *   + path: '',                  // => 如果islink isIframe isApp的通过 links,iframese,apps的键取值，优先高->底 isApp>isframe>islink
     *   M isLink: '',=>isLink:false, // => 改为Boolean 通过 settings 配置地址是否为link，是则将配置的键值links: {'/docs': '//baidu.com', '/user': '//element.eleme.cn'}
     *     isHide: false,             // => 通过 settings 配置是否显示在菜单
     *     isIframe: false,           // => 通过 settings 配置地址是否为isIframe, 是则将配置的键值iframes: {'/docs': '//baidu.com', '/user': '//element.eleme.cn'}
     *   + isApp: false,              // => 追加属性，通过 settings 配置地址是否为子应用，是则将配置的键值apps: {'/docs': '//10.12.68.22/app/docs', '/user': '//10.12.68.22/app/user'}
     *   D permissions:[],            // => 废弃 通过 menuCode 检索
     * },
     * children: [],                  // => childMenuList
     * -----------------------------------------------------------------------------
     * - tenantId: 租户ID
     * + menuId: 同步原菜单ID
     * + parentId: 父菜单ID
     * - menuCode: 菜单CODE   根据此属性，筛选角色需要的菜单
     * + menuName: 菜单名称
     * + menuIcon: 菜单图标
     * + sortNum: 菜单顺序
     * - menuState: 菜单显示状态  0-不显示  1-显示， 不用根据此条件筛选数据，状态码由后台控制，2021年5月12日张富强
     * - applicationCode: 应用code
     * - applicationPageId: 页面id
     * + pageUrl: 页面链接
     * - createTime: 创建事件
     * - updateTime: 更新事件
     * - createUser: 创建人
     * - updateUser: 更新人
     * - childMenuList: 子菜单列表数组
     */
    let menusArray = dealMenu(Menus);

    let menuList = menusArray.filter(menu => {
        if (typeof Auths === 'string' && Auths === 'all') return true;
        else return Auths && Auths.includes(menu.menuCode);
    });



    // 判断是否不过滤权限
    let menuAuth = menuList.map(menu => {
        // 获取父节点数据项, parent: parentChild.pageUrl
        const parentChild = CEUtils.find(menusArray, item => item.menuId === menu.parentId);

        // 获得该节点是否有子节点，返回数量作为判断依据。
        const isChildren = CEUtils.findKey(menuList, item => item.parentId === menu.menuId);

        // 查找匹配第一条数据
        //const childrenFirst = CEUtils.find(menusArray, item => item.parentId === menu.menuId);
        let temp = CEUtils.find(menuList, item => item.parentId === menu.menuId);
        let childrenFirst = {};
        let tempChildMenuList = [];
        if (temp) {
            tempChildMenuList =
                temp &&
                temp.childMenuList &&
                temp.childMenuList.filter(m => {
                    if (typeof Auths === 'string' && Auths === 'all') return true;
                    else return Auths && Auths.includes(m.menuCode);
                });
            childrenFirst = tempChildMenuList.length ? tempChildMenuList[0] : temp;
        }
        //if (!menu.pageUrl && !tempChildMenuList.length) return;

        // /cms/product/news?index=123&bbb=1
        //  /cms/product/news/:index/:bbb
        // pageUrl字符串截取?号前的字符串 /cms/product/news?index=123 => /cms/product/news
        const urlAndParams = menu.pageUrl ? menu.pageUrl.split('?') : [];
        let pageUrl = '';
        if (urlAndParams.length > 1) {
            //把问号后的参数通过params传递
            let params = CEUtils.unserialize(urlAndParams[1]);
            let keys = '/:' + Object.getOwnPropertyNames(params).join('/:');
            pageUrl = urlAndParams[0] + keys;
        } else {
            pageUrl = menu.pageUrl;
        }

        let componentPath = '';
        if (isChildren) {
            componentPath = childrenFirst.pageUrl && childrenFirst.pageUrl.indexOf('?') !== -1 ? childrenFirst.pageUrl.split('?')[0] : childrenFirst.pageUrl;
        } else {
            // const pageUrl = menu.pageUrl.indexOf('?') !== -1 ? urlAndParams[0] : menu.pageUrl;
            componentPath = menu.pageUrl && menu.pageUrl.indexOf('?') !== -1 ? urlAndParams[0] : menu.pageUrl;
        }

        // 是'link', 'iframe', 'app'几种类型,根据路径匹配name值 暂时不用
        const linkName = menu.pageUrl && menu.pageUrl.replace(/[@,#,$,%,^,?,&,*,-,=,//,/,.,:,.html,http,https,-]/g, '');
        // 是'link', 'iframe', 'app'几种类型,则分配动态路径指引到组件 有父节点则拼接url: /cms/zollink or /zollink
        const appPath = '/' + linkName;

        // name属性配置
        let name = '';
        if (urlAndParams.length > 1) {
            let params = CEUtils.unserialize(urlAndParams[1]);
            name = (componentPath ? componentPath.substr(1).replace(/\//g, '-') : '') + '-' + Object.values(params).join('-');
        } else {
            name = componentPath ? componentPath.substr(1).replace(/\//g, '-') : '';
        }
        /**
         * name: 根据pageUrl值格式化 /user/user-list => user-user-list
         * component: 根目录使用 rootComponent 目录使用 nodeComponent 节点使用 pageUrl 其它(apps,iframes,links)使用: nodeComponent
         * meta.parent: 同parentPath
         * meta.isAffix: 使用setting.affixs配置查找对应设置
         * meta.isHide: 使用setting.hides配置查找对应设置
         */

        // 匹配父级
        let parentMenuData = menusArray.filter(v => v.menuId == menu.parentId)

        let _lowcodeList = ['np/category', 'np/app', 'np/form/app', 'np/bulkImport']
        // console.log(_lowcodeList, 999, data[i]['pageUrl'])
        let isLowcode = _lowcodeList.some(v => menu['pageUrl'] && menu['pageUrl'].indexOf(v) > -1)

        let _menu = {
            id: menu.menuId,
            parentId: menu.parentId,
            sort: menu.sortNum,
            path: ['link', 'iframe', 'app'].includes(menu.externalLink) ? appPath || '/z' : pageUrl || '/z', //pageUrl || '/',
            code: menu.menuCode,
            appCode: menu.applicationCode,
            name: name,
            component: isChildren || ['link', 'iframe', 'app'].includes(menu.externalLink) ? nodeComponent : componentPath ? componentPath.substr(1) + '/index' : 'home/index', // componentPath || '/', // && componentPath.substr(1) + '/index',
            meta: {
                parent: ['link', 'iframe', 'app'].includes(menu.externalLink) ? appPath || '/z' : parentChild ? parentChild.pageUrl : pageUrl,
                parentId: menu.parentId,
                icon: menu.menuIcon,
                title: menu.menuName,
                path: ['link', 'iframe', 'app'].includes(menu.externalLink) && menu.pageUrl,
                isApp: menu.externalLink === 'app' ? true : false,
                isIframe: menu.externalLink === 'iframe' ? true : false,
                isLink: menu.externalLink === 'link' ? true : false,
                isAffix: affixs && affixs.includes(name),
                isHide: hides && hides.includes(name),
                helpLink: menu.helpLink || '',
                menuType: menu.thirdAppOpenFlag,
                appCode: menu.applicationCode, // 菜单类型 用thirdAppOpenFlag代表， 2 代表定制应用，需要鉴权
                trackInfo: {
                    // 为埋点服务
                    application_code: isLowcode ? (parentMenuData.length > 0 ? parentMenuData[0].applicationCode : menu['applicationCode']) :  menu['applicationCode'],
                    application_name: isLowcode ? (parentMenuData.length > 0 ? parentMenuData[0].menuName : menu.menuName) : menu.menuName,
                    data_source_id: menu.applicationPageId, // 数据源id
                    data_source_name: menu.menuName, // 数据源名称
                    page_source: menu.pageUrl, // 来源页面  
                }
            },
        };

        const setRedirect = function (itemData, _menu) {
            if (['link', 'iframe', 'app'].includes(itemData.externalLink)) {
                // 是'link', 'iframe', 'app'几种类型,根据路径匹配name值 暂时不用
                const linkName = itemData.pageUrl.replace(/[@,#,$,%,^,?,&,*,-,=,//,/,.,:,.html,http,https,-]/g, '');
                _menu['redirect'] = _menu['path'] == '/z' ? '/' + linkName : _menu['path'] + '/' + linkName;
            } else {
                if (itemData.pageUrl) {
                    console.log(itemData.pageUrl, '=================>itemData.pageUrl');
                    if (itemData.pageUrl.indexOf('?') !== -1) {
                        _menu['redirect'] = itemData.pageUrl.split('?')[0];
                    } else {
                        // _menu['redirect'] = itemData.pageUrl;
                        _menu['redirect'] = itemData.pageUrl.indexOf('?') > -1 ? itemData.pageUrl.replace(/\?appId=/, '/') : itemData.pageUrl;
                    }
                } else {
                    // 从有权限的菜单列表中查找第一个子菜单
                    let nextData = CEUtils.find(menuList, item => item.parentId === itemData.menuId);
                    if (nextData) {
                        setRedirect(nextData, _menu);
                    } else {
                        _menu['redirect'] = '';
                    }
                }
            }
        };

        // 赋值菜单中的第一项连接地址
        if (isChildren) {
            setRedirect(childrenFirst, _menu);
        }

        menu = Object.assign({}, _menu);
        return menu;
    });
    console.log(menuAuth, '2222222');

    menuAuth = menuAuth.filter(res => !!res);
    // menuAuth.forEach(v => {
    //     if (v.meta.appCode == 'visual-manage') {
    //         // console.log('fix: 问题单', getAccessInstance())
    //         // v.meta.path = v.meta.path + '?instance=' + getAccessInstance();
    //         v.meta.path = v.meta.path + '?instance=' + JSON.parse(sessionStorage.getItem('thyTenantInfo'))?.instance;
    //     }
    // });
    // menuAuth数组对象转变为Tree型菜单 api参考: http://10.12.68.61:8070/#/
    const menusTree = CEUtils.toArrayTree(menuAuth, {
        //CEUtils.toArrayTree(mapUnRepeat(menuAuth, 'path'), {
        key: 'id',
        parentKey: 'parentId',
    });
    console.log(menusTree, '3333333333');
    if (!menusTree || (menusTree && menusTree.length == 0)) return [];

    let remenu = {
        id: 0,
        path: '/',
        name: 'root',
        component: rootComponent,
        children: [...menusTree],
    };
    remenu['redirect'] = menusTree[0].path;

    return remenu;
}

// 数据格式(getMenuListByTenantId.js)=>router
// 菜单项会出现重复的菜单，路由器加载时过滤重复菜单项
export function formatMenuData(Menus, Auths) {
    // Menu树转换为数组[]结构，去掉childMenuList的子项数据 api参考: http://10.12.68.61:8070/#/
    /* const menusArray = CEUtils.toTreeArray(Menus, { children: 'childMenuList', clear: false });
    console.log(menusArray, 11111111111); */
    let menusArray = dealMenu(Menus);

    let menuList = menusArray.filter(menu => {
        if (typeof Auths === 'string' && Auths === 'all') return true;
        else return Auths && Auths.includes(menu.menuCode);
    });
    // 判断是否不过滤权限
    let menuAuth = menuList.map(menu => {
        // 获取父节点数据项, parent: parentChild.pageUrl
        const parentChild = CEUtils.find(menusArray, item => item.menuId === menu.parentId);
        // 获得该节点是否有子节点，返回数量作为判断依据。
        const isChildren = CEUtils.findKey(menusArray, item => item.parentId === menu.menuId);
        // 查找匹配第一条数据
        let temp = CEUtils.find(menuList, item => item.parentId === menu.menuId);
        let childrenFirst = {};
        let tempChildMenuList = [];
        if (temp) {
            tempChildMenuList =
                temp &&
                temp.childMenuList &&
                temp.childMenuList.filter(m => {
                    if (typeof Auths === 'string' && Auths === 'all') return true;
                    else return Auths && Auths.includes(m.menuCode);
                });
            childrenFirst = tempChildMenuList.length ? tempChildMenuList[0] : temp;
        }
        //if (!menu.pageUrl && !tempChildMenuList.length) return;
        // pageUrl字符串截取?号前的字符串 /cms/product/news?index=123 => /cms/product/news
        const urlAndParams = menu.pageUrl ? menu.pageUrl.split('?') : [];
        let pageUrl = '';
        if (urlAndParams.length > 1) {
            let params = CEUtils.unserialize(urlAndParams[1]);
            let keys = '/' + Object.values(params).join('/');
            pageUrl = urlAndParams[0] + keys;
        } else {
            pageUrl = menu.pageUrl;
        }
        // 是'link', 'iframe', 'app'几种类型,根据路径匹配name值 暂时不用
        const linkName = menu.pageUrl && menu.pageUrl.replace(/[@,#,$,%,^,?,&,*,-,=,//,/,.,:,.html,http,https,-]/g, '');
        // 是'link', 'iframe', 'app'几种类型,则分配动态路径指引到组件 有父节点则拼接url: /cms/zollink or /zollink
        //const appPath = parentChild ? parentChild.pageUrl + '/' + linkName : '/' + linkName;
        const appPath = '/' + linkName;
        // name属性配置
        const componentPath = menu.pageUrl && menu.pageUrl.indexOf('?') !== -1 ? urlAndParams[0] : menu.pageUrl;
        // name属性配置
        let name = '';
        if (urlAndParams.length > 1) {
            let params = CEUtils.unserialize(urlAndParams[1]);
            name = (componentPath ? componentPath.substr(1).replace(/\//g, '-') : '') + '-' + Object.values(params).join('-');
        } else {
            name = componentPath ? componentPath.substr(1).replace(/\//g, '-') : '';
        }
        /**
         * name: 根据pageUrl值格式化 /user/user-list => user-user-list
         * component: 根目录使用 rootComponent 目录使用 nodeComponent 节点使用 pageUrl 其它(apps,iframes,links)使用: nodeComponent
         * meta.parent: 同parentPath
         * meta.isAffix: 使用setting.affixs配置查找对应设置
         * meta.isHide: 使用setting.hides配置查找对应设置
         */

        // 匹配父级
        let parentMenuData = menusArray.filter(v => v.menuId == menu.parentId)

        let _menu = {
            id: menu.menuId,
            parentId: menu.parentId,
            applicationCode: menu.applicationCode,
            sort: menu.sortNum,
            path: ['link', 'iframe', 'app'].includes(menu.externalLink) ? appPath || '/' : pageUrl || '/', //['link', 'iframe', 'app'].includes(menu.externalLink) ? appPath : pageUrl,
            code: menu.menuCode,
            name: name,
            component: isChildren || ['link', 'iframe', 'app'].includes(menu.externalLink) ? nodeComponent : componentPath || '/', //&& componentPath.substr(1) + '/index'
            meta: {
                parent: ['link', 'iframe', 'app'].includes(menu.externalLink) ? appPath : parentChild ? parentChild.pageUrl : '',
                parentId: menu.parentId,
                path: ['link', 'iframe', 'app'].includes(menu.externalLink) && menu.pageUrl,
                icon: menu.menuIcon,
                title: menu.menuName,
                isApp: menu.externalLink === 'app' ? true : false,
                isIframe: menu.externalLink === 'iframe' ? true : false,
                isLink: menu.externalLink === 'link' ? true : false,
                isAffix: affixs && affixs.includes(name),
                isHide: hides && hides.includes(name),
                helpLink: menu.helpLink || '',
                menuType: menu.thirdAppOpenFlag,
                appCode: menu.applicationCode, // 菜单类型 用thirdAppOpenFlag代表， 2 代表定制应用，需要鉴权
                trackInfo: {
                    // 为埋点服务
                    application_code: parentMenuData.length > 0 ? parentMenuData[0].applicationCode : menu['applicationCode'], // 应用code 取父级，数字门户产品级应用可能没有
                    application_name: parentMenuData.length > 0 ? parentMenuData[0].menuName : menu.menuName, // 应用名称
                    data_source_id: menu.applicationPageId, // 数据源id
                    data_source_name: menu.menuName, // 数据源名称
                    page_source: menu.pageUrl, // 来源页面  
                }

            },
        };
        // 赋值菜单中的第一项连接地址
        const setRedirect = function (itemData, _menu) {
            if (['link', 'iframe', 'app'].includes(itemData.externalLink)) {
                // 是'link', 'iframe', 'app'几种类型,根据路径匹配name值 暂时不用
                const linkName = itemData.pageUrl.replace(/[@,#,$,%,^,?,&,*,-,=,//,/,.,:,.html,http,https,-]/g, '');
                _menu['redirect'] = _menu['path'] == '/' ? '/' + linkName : _menu['path'] + '/' + linkName;
            } else {
                if (itemData.pageUrl) {
                    let urlAndParams1 = childrenFirst.pageUrl ? childrenFirst.pageUrl.split('?') : [];
                    if (urlAndParams1.length > 1) {
                        let params1 = CEUtils.unserialize(urlAndParams1[1]);
                        let keys1 = '/' + Object.values(params1).join('/');
                        _menu['redirect'] = urlAndParams1[0] + keys1;
                    } else {
                        // _menu['redirect'] = itemData.pageUrl;
                        _menu['redirect'] = itemData.pageUrl.indexOf('?') > -1 ? itemData.pageUrl.replace(/\?appId=/, '/') : itemData.pageUrl;
                    }
                } else {
                    // 从有权限的菜单列表中查找第一个子菜单
                    let nextData = CEUtils.find(menuList, item => item.parentId === itemData.menuId);
                    if (nextData) {
                        setRedirect(nextData, _menu);
                    } else {
                        _menu['redirect'] = '';
                    }
                }
            }
        };

        // 赋值菜单中的第一项连接地址
        if (isChildren) {
            setRedirect(childrenFirst, _menu);
        }

        menu = Object.assign({}, _menu);
        return menu;
    });
    console.log(menuAuth, '222222menu');
    menuAuth = menuAuth.filter(res => !!res);
    // menuAuth.forEach(v => {
    //     if (v.meta.appCode == 'visual-manage') {
    //         // console.log('fix: 问题单1', getAccessInstance())
    //         // v.meta.path = v.meta.path + '?instance=' + getAccessInstance();
    //         v.meta.path = v.meta.path + '?instance=' + JSON.parse(sessionStorage.getItem('thyTenantInfo'))?.instance;
    //     }
    // });
    sessionStorage.setItem('menus', JSON.stringify(menuAuth));
    // menuAuth数组对象转变为Tree型菜单 api参考: http://10.12.68.61:8070/#/
    const menusTree = CEUtils.toArrayTree(menuAuth, {
        key: 'id',
        parentKey: 'parentId',
        sortKey: 'sort',
    });
    console.log(menusTree, '3333menu');
    if (!menusTree || (menusTree && menusTree.length == 0)) return [];

    let remenu = {
        id: 0,
        path: '/',
        name: 'root',
        component: rootComponent,
        children: [...menusTree],
    };
    remenu['redirect'] = menusTree[0].path;
    console.log(remenu, '444menu');
    return remenu;
}
